import { connect } from 'react-redux';

import PhotographerComponent from './PhotographerComponent';

const toGender = gender => {
  if (gender.toLowerCase() === 'm') {
    return 'Mann';
  }
  if (gender.toLowerCase() === 'k') {
    return 'Kvinne';
  }
  return 'Ukjent';
};

const mapStateToProps = ({ photographers }, { params }) => {
  const id = !isNaN(params.id) && Number(params.id);
  const photographer = id && photographers.data.find(p => p.id === id);
  if (!photographer) {
    return { isReady: false };
  }
  return {
    shouldRender: true,
    name:
      photographer.name ||
      `${photographer.first_name} ${photographer.last_name}`,
    membership: {
      from: photographer.member_from || 'Ukjent',
      to: photographer.member_to || null,
    },
    prices: photographer.prices,
    positions: photographer.positions,
    error: !photographer,
    born: photographer.born || 'Ukjent',
    died: photographer.died || null,
    gender: toGender(photographer.gender),
    place:
      photographer.county === photographer.place
        ? photographer.place
        : `${photographer.county}, ${photographer.place}`,
  };
};

export default connect(mapStateToProps)(PhotographerComponent);



// WEBPACK FOOTER //
// ./src/pages/Photographer.js